@if (pages && pages.length) {
  <div id="tutorial-wrapper" class="fixed-full">
    <div class="popup-overflow-grey" (click)="closeTutorial()"></div>
    <div class="absolute-center tutorial-popup-wrapper">
      <div class="am-flex-column am-flex-align gap30 height-full padding-top-auto padding-bottom-auto overflow-hidden tutorial-popup">
        <ul class="am-flex-nowrap relative buttons-carousel">
          @for (page of pages; track page) {
            <li class="am-flex-column am-flex-justify am-flex-align gap-auto button-wrapper">
              @if (page.buttonName) {
                <div class="am-flex-column button" [ngClass]="page.class">
                  <span class="pl-l pt-s font-35 color-title-grey button-name">{{page.buttonName}}</span>
                  <span class="am-flex-justify-end pr10 font-icon text-right color-title-grey button-icon" [ngClass]="page.buttonClass"></span>
                </div>
              }
              @if (page.image    ) { <img [src]="page.image" /> }
              @if (page.title    ) { <h3   class="text-xl color-title-grey">{{ page.title }}</h3> }
              @if (page.titleHtml) { <h3   class="text-xl color-title-grey" [innerHTML]="page.titleHtml"></h3> }
              @if (page.desc     ) { <span class="text-l  color-secondary-grey text-tablet-m text-center button-desc">{{page.desc}}</span> }
              @if (page.descHtml ) { <span class="text-l  color-secondary-grey text-tablet-m text-center button-desc" [innerHTML]="page.descHtml"></span> }
            </li>
          }
        </ul>
        <div class="am-flex-justify am-flex-align width-full padding-left-auto padding-right-auto relative">
          @if (pages.length > 1) {
            <button class="short-btn" [ngClass]="currentPage ? 'blue-thin-border' : 'blue-no-border' "
              (click)="currentPage ? changePage(currentPage - 1) : closeTutorial()">
              {{ currentPage ? 'Zurück' : 'Schließen' }}
            </button>
            <div class="am-flex-justify gap-s">
              @for (bullet of pages; track bullet; let i = $index) {
                <span class="dot" (click)="changePage(i)" [class.active]="currentPage === i"></span>
              }
            </div>
            <button class="short-btn" [ngClass]="currentPage === (pages.length - 1) ? 'blue-no-border' : 'blue-thin-border'"
              (click)="currentPage === (pages.length - 1) ? closeTutorial() : changePage(currentPage + 1)">
              {{ currentPage === (pages.length - 1) ? 'Schließen' : 'Weiter' }}
            </button>
          }
          @if (pages.length === 1) { <button class="ma short-btn blue-thin-border" (click)="closeTutorial()">OK</button> }
        </div>
        <div class="pl30 pb-s mra am-flex-align">
          <input class="custom-checkbox white big" type="checkbox" id="tutorial_checkbox" [(ngModel)]="passTutorial">
          <label class="font-s" for="tutorial_checkbox">Diese Meldung nicht mehr anzeigen</label>
        </div>
      </div>
    </div>
  </div>
}
